import algosdk from "algosdk";
import { useNavigate } from "react-router-dom";
import Modal from "../components/Modal";
import Footer from "../components/Footer";
import { useEffect, useState } from "react";
import { FaRegCopy } from "react-icons/fa";
import { useWallet } from "../context/WalletContext";
import "../styles/home.css";
import "../styles/decoration/Footer.css";

interface HomeProps {
  algodClient: algosdk.Algodv2;
  setMessage: (msg: string) => void;
  account: string;
  username: string;
  algoBalance: number;
  umqBalance: number;
  hlkBalance: number;
  logout: () => void;
}

const Home: React.FC<HomeProps> = ({
  algodClient,
  account: accountAddress,
  algoBalance,
  umqBalance,
  hlkBalance,
}) => {
  const navigate = useNavigate();
  const { setAccount } = useWallet();
  const { username } = useWallet();
  const [copied, setCopied] = useState(false);
  const [minBalance, setMinBalance] = useState<number>(100000);

  useEffect(() => {
    const fetchMinBalance = async () => {
      try {
        if (accountAddress) {
          const info = await algodClient.accountInformation(accountAddress).do();
          setMinBalance(info["min-balance"]);
        }
      } catch (error) {
        console.error("Error obteniendo mínimo requerido:", error);
      }
    };

    fetchMinBalance();
  }, [accountAddress, algodClient]);

  const handleCopy = () => {
    navigator.clipboard.writeText(accountAddress);
    setCopied(true);
    postMessage("");
    setTimeout(() => setCopied(false), 4500);
  };

  const handleLogout = () => {
    setAccount(null);
    navigate("/");
  };

  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState("");

  const handleOpenModal = (type: string) => {
    setModalType(type);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setModalType("");
  };

  const renderModalContent = () => {
    switch (modalType) {
      case "wallet":
        return (
          <div>
            <h2>Mox Wallet</h2>
            <p>Administra tus activos y transacciones con seguridad.</p>
            <button onClick={() => navigate("/wallet")} className="modal-button">Perfil</button>
            <p>Y si estás recién llegado, reclama tus UMQ de regalo.</p>
            <button onClick={() => navigate("/referido")} className="modal-button">Bienvenida</button>
          </div>
        );
      case "quizz":
        return (
          <div>
            <h2>Mox Quizz</h2>
            <p>Participa en nuestras trivias, juega y gana.</p>
            <h4><strong>1°: 5 USDC</strong> <img src="/images/usdc_mox.png" width="34" height="34" style={{ borderRadius: "50%" }} /></h4>
            <h4><strong>2°: 1.000 UMQ</strong> <img src="/images/umq.avif" width="34" height="34" /></h4>
            <h4><strong>3°: 500 UMQ</strong> <img src="/images/umq.avif" width="34" height="34" /></h4>
            <button onClick={() => navigate("/quizz")} className="modal-button">Iniciar</button>
          </div>
        );
      case "games":
        return (
          <div>
            <h2>Mox Juegos</h2>
            <p>Participa en nuestros juegos y gana.</p>
            <button onClick={() => navigate("/roulette")} className="modal-button">Ruleta</button>
            <button onClick={() => navigate("/target")} className="modal-button">Tiro</button>
          </div>
        );
      case "stake":
        return (
          <div>
            <h2>Mox Stake</h2>
            <p>💸 Staking Holkan</p>
            <p>Haz stake de tus UMQ y gana recompensas cada segundo.</p>
            <button onClick={() => navigate("/stake")} className="modal-button">Iniciar</button>
          </div>
        );
      case "market":
        return (
          <div>
            <h2>Centro de Energia</h2>
            <p>Cada acción genera energia,recompensa.</p>
            <button onClick={() => navigate("/proveedores")} className="modal-button-1">Creadores</button>
            <button onClick={() => navigate("/eventos")} className="modal-button-2">Eventos</button>
            <button onClick={() => navigate("/marketplace")} className="modal-button-2">Canjea tus Mox Coins</button>
          </div>
        );
      case "news":
        return (
          <div>
            <h2>Noticias</h2>
            <p>Mantente al día con novedades y lanzamientos.</p>
            <button onClick={() => navigate("/news")} className="modal-button">Entrar</button>
          </div>
        );
      default:
        return null;
    }
  };
  

  return (
    <div className="home-container">
      <div className="home-left">
        <div className="user-info">
          <h2>{username}</h2>
          <h4>
            <strong>Cuenta No:</strong> {accountAddress.slice(0, 6)}...{accountAddress.slice(-8)}
            <FaRegCopy onClick={handleCopy} title="Copiar dirección completa" className="copy-icon" />
            {copied && <span className="message">Copiado</span>}
          </h4>

          <div className="balances">
            <div className="balance-item">
              <div className="balance-label">
                <img src="/images/umq.avif" alt="UMQ" width="60" height="60" />
                <p>Energia Del Reconocimiento</p>
              </div>
              <div className="balance-bar-container">
                <div className="balance-bar umq" style={{ width: `${Math.min(umqBalance / 100, 1) * 100}%` }}></div>
              </div>
              <p className="balance-value">{umqBalance.toFixed(2)}</p>
            </div>
            <div className="balance-item">
              <div className="balance-label">
                <img src="/images/holkan.avif" alt="HLK" width="60" height="60" />
                <p>Energia Creadora</p>
              </div>
              <div className="balance-bar-container">
                <div className="balance-bar hlk" style={{ width: `${Math.min(hlkBalance / 100, 1) * 100}%` }}></div>
              </div>
              <p className="balance-value">{hlkBalance.toFixed(2)}</p>
            </div>
            <div className="balance-item">
              <div className="balance-label">
                <img src="/images/algo_new.png" alt="ALGO" width="60" height="60" style={{ borderRadius: "50%" }} />
                <p>ALGO</p>
              </div>
              <div className="balance-bar-container">
                <div className="balance-bar algo" style={{ width: `${Math.min(algoBalance / 10, 1) * 100}%` }}></div>
              </div>
              <p className="balance-value">{algoBalance.toFixed(2)}</p>
            </div>
          </div>

          <p>
            <strong>Mín. requerido:</strong>
            <img src="/images/algo_new.png" alt="ALGO" width="28" height="28" style={{ borderRadius: "50%", margin: "0 8px", backgroundColor: "grey" }} />
            {(minBalance / 1e6).toFixed(2)} ALGO
          </p>

          <button className="button-primary" onClick={handleLogout}>Conectarse</button>
        </div>
      </div>

      <div className="home-right">
        <div className="button-grid">
          <button className="action-button img2" onClick={() => handleOpenModal("market")}>Participa y Canjea</button>
          <button className="action-button img5" onClick={() => handleOpenModal("games")}>Juega y Gana</button>
          <button className="action-button img4" onClick={() => handleOpenModal("stake")}>Holdea y Gana</button>
          <button className="action-button img1" onClick={() => handleOpenModal("wallet")}>Envia Mox coins</button>
        </div>
        <h5>Memecosistema Mox Holkan</h5>
        <div className="home-footer">
        <Footer />
        </div>
        <Modal isOpen={modalOpen} onClose={handleCloseModal}>
          {renderModalContent()}
        </Modal>
      </div>
    </div>
  );
};

export default Home;